module.exports = __webpack_public_path__ + "static/drag_and_drop_form@2x.724b0f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_form@2x.png
// module id = 219
// module chunks = 193162123475590 216210090109534